import catalogo from "../../assets/home/catalogo2025.png";
import catalogo2027 from "../../assets/home/catalogo2027.png";

function Categories() {

    return (
        <>
            <article className="section-title">
                <h2 className="title-line">CATÁLOGO</h2>
                <div className="title-line-line"></div>
            </article>
            <article className="catalogo-section">

                <div className="description">
                    <p>
                        Conoce nuestra colección de
                        recubrimientos, pisos y soluciones
                        decorativas para transformar cada
                        espacio.

                    </p>
                    <p>
                        Explora nuestros productos,
                        diseños y acabados, y encuentra
                        la opción ideal para tu próximo
                        proyecto.
                    </p>

                </div>
                <section className="catalogo-column">

                    <a href="https://www.woodart.com.mx/catalogos/WoodArt_2027.pdf">
                        <img className="catalogoimg" src={catalogo2027} alt="imagen-2026" />
                    </a>
                </section>
            </article>
        </>
    );
}

export default Categories;